import { Fancybox } from '@fancyapps/ui';

const onShown = (fancybox, slide) => {
  const overlay = document.getElementById('zoomOverlay');
  if (overlay) {
    overlay.classList.add('active');
    setTimeout(() => overlay.classList.remove('active'), 2000);
  }

  const panzoom = slide?.panzoom;
  if (!panzoom) return;
  const zoomPercent = parseFloat(slide.triggerEl?.dataset.zoom || 1);

  panzoom.zoomTo(zoomPercent, {
    originX: 0.5,
    originY: 0.5,
  });
};

const initFancybox = () => {
  Fancybox.bind('[data-fancybox]', {
    Toolbar: {
      display: {
        left: [],
        middle: [],
        right: ['close'],
      },
    },
    on: {
      reveal: onShown,
      done: onShown,
    },
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initFancybox);
} else {
  initFancybox();
}
